import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Observable, of, Subject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { CurrentUser } from 'modules/shared/models/account.models';
import { Domain } from 'modules/shared/models/domain.models';

import { Selectors, AppState, Actions } from 'store/root-reducer';
import { State as AuthState } from 'store/reducers/auth.reducers';
import { DomainsQuery } from 'store/models/domain.models';

import * as DomainActions from 'store/actions/domain.actions';
import { AdminService } from 'modules/core/services/admin.service';

@Component({
  selector: 'artemis-select-domain',
  templateUrl: './select-domain.component.html',
  styleUrls: ['./select-domain.component.scss']
})
export class SelectDomainComponent implements OnInit, OnDestroy {

  private unsubscribe$: Subject<void> = new Subject();

  constructor(private store: Store<AppState>,
    private route: ActivatedRoute,
    private adminService: AdminService,
    private router: Router) { }

  loading$: Observable<boolean>;
  domains: Observable<Domain[]>;
  domain: Domain;
  profileStore$: Observable<AuthState> = this.store.select(Selectors.auth.getAuth);
  payload: DomainsQuery = {
    limit: 999
  };

  ngOnInit() {
    this.profileStore$ = this.store.select(Selectors.auth.getAuth);
    this.domains = this.store.select(Selectors.domain.getDomains);
    this.store.select(Selectors.domain.getCurrentDomain)
      .pipe(
        takeUntil(this.unsubscribe$)
      ).subscribe((domain: Domain) => {
        if (this.domain && domain) {
          this.router.navigateByUrl(this.route.snapshot.queryParams.redirect || 'dashboard');
        }
      });
    this.store.select(Selectors.auth.getUser)
      .pipe(
        takeUntil(this.unsubscribe$)
      ).subscribe((user: CurrentUser) => {
        if (user && user.hasOwnProperty('signInUserSession')) {
          this.store.dispatch(new Actions.domain.LoadList(this.payload));
        }

        if (user) {
          this.adminService
            .checkLastLogin(user.sub)
            .pipe(
              takeUntil(this.unsubscribe$),
              switchMap((e) => of(e))
            ).subscribe();
        }
      });

      this.initLoading();
  }

  /**
   * Inits observables for loading spinner
   * @method initLoading
   */
  private initLoading(): void {
    this.loading$ = this.store.select(Selectors.domain.getLoading)
      .pipe(
        takeUntil(this.unsubscribe$),
        map((loadingActionsList: Array<DomainActions.DomainActionTypes>) => {
          return loadingActionsList.includes(DomainActions.DomainActionTypes.LOAD_DOMAIN_LIST);
        })
      );
  }

  chooseDomain() {
    this.store.dispatch(new Actions.domain.SetDomain(this.domain));
  }

  logOut(): void {
    this.store.dispatch(new Actions.auth.LogOut({ isSessionTimeOut: false }));
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
